<div class="modal fade" id="routerModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title fw-bold word-wrap"><span jhiTranslate="germplasm-details.header">Germplasm Details:</span> <span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">{{germplasm?.preferredName  | truncateWithEllipsis:MAX_NAME_DISPLAY_SIZE}}</span> (GID: {{germplasm?.gid}})</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="float-end pt-1">
                    <a [href]="safeUrl" target="_blank" class="btn btn-outline-info"><i class="fa fa-external-link fa-lg" aria-hidden="true"></i></a>
                </div>
                <div class="container-fluid pt-3 pb-3">
                    <ul class="nav nav-tabs">
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['germplasm-basic-details'] } }]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.germplasm">Germplasm</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['attributes'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.descriptors">Descriptors</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION"
                               [routerLink]="[{ outlets: { modalContent: ['pedigree'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.pedigree">Pedigree</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['observations'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.observations">Observations</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['inventory'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.inventory">Inventory</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['lists'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.lists">Lists</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['samples'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.samples">Samples</a>
                        </li>
                        <li class="nav-item pe-1" *ngIf="isFileStorageConfigured">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['files'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.files.tab">Files</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link" [routerLink]="[{ outlets: { modalContent: ['genotyping'] }}]"
                               [routerLinkActive]="['active']"
                               [routerLinkActiveOptions]="{exact: true}"
                               queryParamsHandling="preserve"
                               jhiTranslate="germplasm-details.genotyping">Genotyping</a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane container-fluid active">
                            <router-outlet name="modalContent"></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




